import React from 'react';
import { useSpring, animated, config } from 'react-spring';
import styled from 'styled-components';

import TitleCard, { MyPlanet } from './Cards/TitleCard';
import InfoCard from './Cards/InfoCard';


const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const ContainerAnimated = animated(Container);

const App = () => {
  const fadeInProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 1000 }
  });

  return (
    <ContainerAnimated style={fadeInProps}>
      <TitleCard name="Роман Медников" photo={process.env.PUBLIC_URL + '/person.jpg'}/>
      <InfoCard />
    </ContainerAnimated>
  );
}

export default App;
